<template>
  <div class="custom-el-page">
    <div v-if="mini" class="el-custom-mini-page">
      <div class="font-size-14 flex-center c-999">
        <span class="arrow-circle cursor-pointer" @click="handleMiniPageChange('pre')">
          <GeneralIconArrowLeft :size="12" :color="initialPage === 1 ? '#ccc' : '#333'" />
        </span>
        <span class="c-333 font-weight-500 ml10">{{ initialPage }}</span>
        <span>/</span>
        <span class="mr10">{{ miniTotalPage }}</span>
        <span class="arrow-circle cursor-pointer" @click="handleMiniPageChange('next')">
          <GeneralIconArrowRight :size="12" :color="initialPage >= miniTotalPage ? '#ccc' : '#333'" />
        </span>
      </div>
    </div>
    <bd-pagination
      v-else
      class="bordered flex-end"
      :current-page="initialPage"
      :page-size="intialSize"
      :page-sizes="pageSizes"
      background
      layout="total, sizes, prev, pager, next"
      :total="total"
      :hide-on-single-page="false"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </div>
</template>

<script>
import { GeneralIconArrowLeft, GeneralIconArrowRight } from '@bilibili-business/icons-vue-plus'
const COMPONENT_NAME = 'el-page'

export default {
  name: COMPONENT_NAME,
  emits: ['change', 'update:page', 'update:size'],
  components: { GeneralIconArrowLeft, GeneralIconArrowRight },
  props: {
    page: Number,
    size: Number,
    total: Number,
    pageSizes: {
      type: Array,
      default() {
        return [5, 8, 10, 15, 20, 30, 40, 50, 100]
      }
    },
    mini: Boolean
  },
  data() {
    return {
      initialPage: this.page,
      intialSize: this.size
    }
  },
  watch: {
    page(newVal) {
      this.initialPage = newVal
      // 专门处理搜索置空，page回归1
    }
  },
  computed: {
    miniTotalPage() {
      return this.mini && this.total ? Math.ceil(this.total / this.size) : 1
    }
  },
  methods: {
    handleSizeChange(size) {
      this.initialPage = 1
      this.intialSize = size
      this.$emit('update:size', size)
      this.handleCurrentChange(1)
    },
    handleCurrentChange(page) {
      this.initialPage = page
      this.$emit('update:page', page)
      this.$emit('change')
    },
    handleMiniPageChange(type) {
      if ((type === 'pre' && this.initialPage === 1) || (type === 'next' && this.initialPage >= this.miniTotalPage)) {
        return
      }

      if (type === 'pre') {
        this.initialPage = this.initialPage - 1
      }
      if (type === 'next') {
        this.initialPage = this.initialPage + 1
      }

      this.$emit('update:page', this.initialPage)
      this.$emit('change')
    }
  }
}
</script>

<style lang="less">
.el-custom-mini-page {
  .arrow-circle {
    width: 24px;
    height: 24px;
    border: 1px solid #e6e6e6;
    border-radius: 24px;
    line-height: 24px;
    text-align: center;
  }
}
</style>
